import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faIdCard, faFileSignature } from "@fortawesome/free-solid-svg-icons";

library.add(faIdCard, faFileSignature);

const LandingPage = lazy(() => import("./pages/LandingPage/LandingPage"));
const PageNotFound = lazy(() => import("./pages/PageNotFound/PageNotFound"));
const Welcome = lazy(() => import("./pages/Welcome"));
const Thankyou = lazy(() => import("./pages/Thankyou"));
const Waiting = lazy(() => import("./pages/Waiting"));

const theme = createTheme();

function detectLocale() {
  const supported = ["en", "de", "ru"];
  const langs = navigator.languages || [navigator.language || "en"];
  return (
    langs.map((l) => l.split("-")[0]).find((l) => supported.includes(l)) || "en"
  );
}

const App = () => {
  const locale = detectLocale();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <IntlProvider locale={locale} messages={{}} onError={() => {}}>
        <BrowserRouter>
          <Suspense fallback={null}>
            <Switch>
              <Route path="/welcome" component={Welcome} />
              <Route path="/thankyou" component={Thankyou} />
              <Route path="/waiting" component={Waiting} />
              <Route path="/" component={LandingPage} />
              <Route component={PageNotFound} />
            </Switch>
          </Suspense>
        </BrowserRouter>
      </IntlProvider>
    </ThemeProvider>
  );
};

export default App;
